const CLAIM_ADMIN = "admin";
const CLAIM_USER = "user";
const CLAIM_RUNNER = "runner";
const CLAIM_VENDOR = "vendor";
const CLAIMS = [CLAIM_USER, CLAIM_RUNNER, CLAIM_VENDOR, CLAIM_ADMIN];

export { CLAIM_ADMIN, CLAIM_USER, CLAIM_VENDOR, CLAIM_RUNNER, CLAIMS };
